export default function(){
        return window.location.pathname;
}


//////////////////
// WEBPACK FOOTER
// ./src/utils/get-url-path.js
// module id = 12
// module chunks = 0